import { useEffect } from "react";
import { Box, Heading, VStack, Text, Link } from "@chakra-ui/layout";
import Stepper from "../Custom/Stepper/Stepper";
import PageHeading from "../UI/PageHeading";
import { useWeb3 } from "@chainsafe/web3-context";
import { useToast } from "@chakra-ui/react";
import { toastWarning } from "../../config/toast";
import React from "react";
import { getFeatureFlagStatus } from "../../featureFlags";

const shadowForkMessagesEnabled = getFeatureFlagStatus(
  "shadowForkMessagesEnabled"
);

const ConfigurePage = () => {
  const { isReady, onboard, wallet, checkIsReady } = useWeb3();
  const toast = useToast();
  let sBrowser: any,
    sUsrAg: any = navigator.userAgent;

  async function checkWallet() {
    !wallet && (await onboard?.walletSelect());
    wallet && (await checkIsReady());
  }

  useEffect(() => {
    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      sBrowser === "Mozilla Firefox" &&
        toast({
          ...toastWarning,
          title: "Warning!",
          description: "This flow may not work properly in Firefox.",
        });
    }
  }, []);

  useEffect(() => {
    if (onboard) {
      !isReady && checkWallet();
    }
  }, [onboard]);

  return (
    <VStack align="stretch" ml="0px" mr="0px">
      <PageHeading title="Configure Wallet" />
      {shadowForkMessagesEnabled && (
        <Box pl="8px" color="palmNetwork.100" bg="palmNetwork.800">
          <Box pb="32px" pt="48px" maxW="728px" pl="16px">
            <Heading fontSize="24px" mb="16px">
              Shadow Fork Testnet testing
            </Heading>
            <Text mb="16px">
              Here you can add the shadow fork Palm Testnet RPC to your wallet.
              MetaMask may give a warning that the RPC URL value does not match
              a known provider for the chain ID, but it&apos;s safe to proceed.
              You may wish to use a new wallet account to avoid nonce sequence
              issues when creating new transactions.
            </Text>
            <Text mb="16px">
              Please refer to the Palm network documentation for details at{" "}
              <Link>https://docs.palm.io/network-update</Link>
            </Text>
          </Box>
        </Box>
      )}
      <Stepper />
    </VStack>
  );
};

export default ConfigurePage;
